export default class GraphqlError extends Error {

  /** @type {string} */
  #query;

  /** @type {Map<string, any>} */
  #variables;

  /**
   * 
   * @param {string} message 
   * @param {string} query 
   * @param {{
   *   variables?: Map<string, any>;
   * }} kwargs
   */
  constructor(message, query, { variables }) {
    super(message);
    
    this.#query = query;
    this.#variables = variables;
  }

  /**
   * Gets the variables that were used in the Graphql request that caused
   * this error. May be undefined
   */
  get variables() {
    return this.#variables;
  }

  /**
   * Gets the query that was used in the graphql request that cause this
   * error.
   */
  get qeury() {
    return this.#query;
  }
}